import React from "react";
import ServiceCard from "./WhyCard";
import {
  IoMdCodeWorking,
  IoIosRocket,
  IoIosAnalytics,
  IoIosGlobe,
} from "react-icons/io";
import { Link } from "react-router-dom";
import WhyCard from "./WhyCard";

const servicesData = [
  // Existing services...
  {
    icon: (
      <IoMdCodeWorking className="text-orange-500 group-hover:text-white text-5xl" />
    ),
    title: "Cutting-Edge Technology",
    description:
      "We utilize the latest technological advancements to provide you with innovative solutions that stay ahead of the curve.",
  },
  {
    icon: (
      <IoIosRocket className="text-orange-500 group-hover:text-white text-5xl" />
    ),
    title: "Fast and Efficient Service",
    description:
      "Our team is dedicated to delivering quick and efficient services, ensuring you save time and stay productive.",
  },
  {
    icon: (
      <IoIosAnalytics className="text-orange-500 group-hover:text-white text-5xl" />
    ),
    title: "Data-Driven Insights",
    description:
      "We provide comprehensive data analysis to help you make informed decisions and optimize your business strategy.",
  },
  {
    icon: (
      <IoIosGlobe className="text-orange-500 group-hover:text-white text-5xl" />
    ),
    title: "Global Reach",
    description:
      "With a global network, we can assist you in expanding your business across borders and reaching new markets.",
  },
  // Two new services...
  {
    icon: (
      <IoMdCodeWorking className="text-orange-500 group-hover:text-white text-5xl" />
    ),
    title: "24/7 Support",
    description:
      "We offer round-the-clock support to ensure your technology solutions are always up and running.",
  },
  {
    icon: (
      <IoIosRocket className="text-orange-500 group-hover:text-white text-5xl" />
    ),
    title: "Customized Solutions",
    description:
      "We tailor our services to meet your unique business needs, providing customized solutions that drive success.",
  },
];

const Why = () => {
  return (
    <div className=" py-20 px-[10px] md:px-[20px] lg:px-[7%]">
      <div className="flex lg:flex-row flex-col lg:items-center lg:justify-between">
        <div>
          <h4 className="font-bold text-sm text-slate-600">
            Elevating Your Success
          </h4>
          <h1 className="text-3xl font-extrabold text-black pb-2">
            Why Choose Us
          </h1>
        </div>
      </div>

      <div className="py-12 grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {servicesData.map((service, index) => (
          <WhyCard
            key={index}
            title={service.title}
            description={service.description}
            icon={service.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default Why;
